export enum Keywords {
    USER_PERMISSIONS = "userPermissions",
    USER_INFO = "userInfo",
    
}